import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-text-center h-mb-30" }
const _hoisted_2 = { class: "b-base-title h-mt-10" }
const _hoisted_3 = { class: "h-flex h-flex-center h-width-100p" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwInput = _resolveComponent("FwInput")!
  const _component_FwFormInput = _resolveComponent("FwFormInput")!
  const _component_FwButton = _resolveComponent("FwButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('AUTH.RESET_PASSWORD.TITLE')), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("form", {
        class: "h-mt-15",
        onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendDataToServer && _ctx.sendDataToServer(...args)), ["enter"]))
      }, [
        _createVNode(_component_FwFormInput, {
          class: "h-mb-25",
          fieldHasError: _ctx.fieldHasErrorByRule(_ctx.password, _ctx.PASSWORD, _ctx.passwordRules),
          labelType: "label-thin",
          title: _ctx.$t(`AUTH.FORGET_PASSWORD.NEW.ONE`)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FwInput, {
              value: _ctx.password,
              type: "password",
              name: "password",
              placeholder: _ctx.$t(`AUTH.LOGIN.FORM.PASSWORD.PLACEHOLDER`),
              inputStyle: "gray",
              error: _ctx.getFieldErrorTextByRule(_ctx.password, _ctx.PASSWORD, _ctx.passwordRules),
              onUpdate: _cache[0] || (_cache[0] = value => _ctx.password = value),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearServerErrorsBase(_ctx.PASSWORD))),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addCurrentInputToValidateArray(_ctx.PASSWORD)))
            }, null, 8, ["value", "placeholder", "error"])
          ]),
          _: 1
        }, 8, ["fieldHasError", "title"]),
        _createVNode(_component_FwFormInput, {
          class: "h-mb-15",
          fieldHasError: _ctx.fieldHasErrorByRule(_ctx.password_repeat, _ctx.PASSWORD_REPEAT, _ctx.passwordRules),
          labelType: "label-thin",
          title: _ctx.$t(`AUTH.FORGET_PASSWORD.NEW.TWO`)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FwInput, {
              value: _ctx.password_repeat,
              type: "password",
              name: "password",
              placeholder: _ctx.$t(`AUTH.LOGIN.FORM.PASSWORD.PLACEHOLDER`),
              inputStyle: "gray",
              error: _ctx.getFieldErrorTextByRule(_ctx.password_repeat, _ctx.PASSWORD_REPEAT, _ctx.passwordRules),
              onUpdate: _cache[3] || (_cache[3] = value => _ctx.password_repeat = value),
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearServerErrorsBase(_ctx.PASSWORD_REPEAT))),
              onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addCurrentInputToValidateArray(_ctx.PASSWORD_REPEAT)))
            }, null, 8, ["value", "placeholder", "error"])
          ]),
          _: 1
        }, 8, ["fieldHasError", "title"])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_FwButton, {
        class: "h-mt-30",
        borderRadiusType: "small-border",
        disabled: !_ctx.isFormValid,
        onClick: _ctx.sendDataToServer
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('AUTH.RESET_PASSWORD.BUTTON')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}